import FlexBox from '@/atomic-components/FlexBox';
import { useCart } from '@/hooks/useCart';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, Typography } from '@mui/material';
import PaymentPlanGlobalTile from './PaymentPlanGlobalTile';
import PaymentPlanCta from '@/assets/cart/payment-plan-cta.svg';
import { LencoImage } from '@/atomic-components/Image';

type TenureSelectorProps = {
	tenureSelector: any;
	bulkTenureUpdate: (tenure: number, price?: number) => void;
	openTenureSelector: () => void;
	setItemSelectedForTenureSelector: any;
	closeTenureSelector: () => void;
	tenureSelectorvisible: any;
};

const TenureSelector: React.FC<TenureSelectorProps> = ({
	setItemSelectedForTenureSelector,
	tenureSelector,
	bulkTenureUpdate,
	openTenureSelector,
	closeTenureSelector,
	tenureSelectorvisible,
}) => {
	const { rentCart } = useCart();
	const showEmptyState =
		!tenureSelectorvisible ||
		(Array.isArray(tenureSelectorvisible) &&
			tenureSelectorvisible.length === 0);

	return (
		<>
			{!showEmptyState ? (
				<Box>
					<FlexBox
						sx={{
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'center',
							padding: '14px 30px',
							borderBottom: '1px solid #e8e8e8',
							gap: '7px',
						}}
					>
						<FlexBox
							direction='column'
							sx={{
								justifyContent: 'center',
								alignItems: 'center',
								width: '100%',
								gap: '2px',
							}}
							onClick={() => openTenureSelector()}
						>
							<FlexBox
								sx={{
									justifyContent: 'space-between',
									width: '100%',
									cursor: 'pointer',
								}}
							>
								<Typography
									sx={{
										...getStyle('P_Medium'),
										color: getColor('Gray 0'),
										cursor: 'pointer',
									}}
								>
									{rentCart?.tenureSelector?.textElement?.collapsed?.title}
								</Typography>
								<Box>
									<PaymentPlanCta />
								</Box>
							</FlexBox>
							<FlexBox sx={{ width: '100%', justifyContent: 'start' }}>
								<Typography
									sx={{
										...getStyle('Small_Regular'),
										color: getColor('Gray 0'),
										// maxWidth: 'calc(100vw - 81px)',
									}}
								>
									{rentCart?.tenureSelector?.textElement?.collapsed?.subtitle}
								</Typography>
							</FlexBox>
						</FlexBox>
						<FlexBox
							sx={{
								justifyContent: 'flex-start',
								gap: '14px',
								width: '100%',
								flexWrap: 'nowrap',
								overflow: 'scroll',
								padding: '8px 0',
								alignItems: 'center',
							}}
						>
							{[
								...(rentCart?.tenureSelector?.monthlyPaymentPlans
									?.paymentPlans || []),
								...(rentCart?.tenureSelector?.upfrontPaymentPlans
									?.paymentPlans || []),
							]?.map((item: any) => {
								return (
									<PaymentPlanGlobalTile
										key={item?.tenure}
										selected={rentCart?.tenureSelector?.selectedTenure}
										tenure={item}
										onTenureTileClick={bulkTenureUpdate}
										showBulkTenureSelector={openTenureSelector}
									/>
								);
							})}
						</FlexBox>
						{!rentCart?.tenureSelector?.selectedTenure ? (
							<Box
								sx={{
									...getStyle('Small_Regular'),

									color: getColor('Gray 0'),
									background: getColor('Minty -4'),
									width: '100%',
									padding: '7px 0',
									textAlign: 'center',
									borderRadius: '5px',
								}}
							>
								{' '}
								Multiple payment plan selected{' '}
							</Box>
						) : (
							<></>
						)}
					</FlexBox>
				</Box>
			) : (
				<FlexBox
					sx={{
						justifyContent: 'center',
						alignItems: 'center',
						height: '180px',
						width: '95%',
						position: 'relative',
					}}
				>
					<Box
						sx={{ height: '', width: '100%', position: 'absolute', top: 10, left: "20px" }}
					>
						<LencoImage url='https://assets.furlenco.com/s3-furlenco-images/evolve_2_0/summary_cart_update_desktop.png' />
					</Box>
				</FlexBox>
			)}
		</>
	);
};

export default TenureSelector;
